import { axiosClient } from "./client";
import {
  GET_RESERVED_LESSONS,
  GET_NOT_USED_LESSONS,
  GET_COMPLETED_LESSONS,
  GET_GROUP_LESSONS,
  STUDENT_LESSONS_FILTER,
  GET_MY_LESSONS,
  RESERVE_LESSON_CANCEL,
  RESERVE_LESSON_CHANGE_SCHEDULE, 
  RESERVE_LESSON_REFUND,
  RESERVE_LESSON_NO_DATE
} from "./client/endpoints";
import { MyLesson, reservationChangeSchedulePayload } from "./service-models";

const studentLessonsFilter = async (query: any): Promise<any> => {
  const response = await axiosClient.get<any>(STUDENT_LESSONS_FILTER, {
    params: query,
  });
  return response.data.data?.[0];
};

const getMyLessons = async (): Promise<MyLesson[]> => {
  const response = await axiosClient.get<{ data: MyLesson[] }>(GET_MY_LESSONS);
  return response.data.data;
};

const cancelStudentLessonReservation = async (
  reservation_id: number
): Promise<any> => {
  const response = await axiosClient.post<any>(RESERVE_LESSON_CANCEL, {
    reservation_id,
  });
  return response.data.data;
};

const refundStudentLessonReservation = async (
  reservation_id: number
): Promise<any> => {
  const response = await axiosClient.post<any>(RESERVE_LESSON_REFUND, {
    reservation_id,
  });
  return response.data.data;
};

const changeStudentLessonReservation = async (
  data: reservationChangeSchedulePayload
): Promise<any> => {
  const response = await axiosClient.post<any>(
    RESERVE_LESSON_CHANGE_SCHEDULE,
    data
  );
  return response.data.data;
};

const fetchReservedLessons = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_RESERVED_LESSONS);
    return response.data;
  } catch (e) {
    return [];
  }
};

const fetchNotUsedLessons = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_NOT_USED_LESSONS);
    return response.data;
  } catch (e) {
    return [];
  }
};

const fetchCompletedLessons = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_COMPLETED_LESSONS);
    return response.data;
  } catch (e) {
    return [];
  }
};

const fetchGroupLessons = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_GROUP_LESSONS);
    return response.data;
  } catch (e) {
    return [];
  }
};

const notifyNoAvailableReservations = async (data: { lesson_id: string }): Promise<any> => {
  const response = await axiosClient.post<any>(RESERVE_LESSON_NO_DATE, data);
  return response.data;
};

const StudentsService = {
  studentLessonsFilter,
  getMyLessons,
  cancelStudentLessonReservation,
  refundStudentLessonReservation,
  changeStudentLessonReservation,
  fetchReservedLessons,
  fetchNotUsedLessons,
  fetchCompletedLessons,
  fetchGroupLessons,
  notifyNoAvailableReservations,
};

export default StudentsService;
